import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VDropdownShortcut' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ''
		},
		keys: {
			type: String,
			default: ''
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("kbd", {
    class: _normalizeClass(_unref(clsx)(__props.className, 'col-start-5 row-start-1 flex justify-self-end'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((Array.isArray(__props.keys) ? __props.keys : __props.keys.split('')), (char, index) => {
      return (_openBlock(), _createElementBlock("kbd", {
        key: index,
        class: _normalizeClass(_unref(clsx)([
				'min-w-[2ch] text-center font-sans capitalize text-zinc-400 group-data-[focus]:text-white forced-colors:group-data-[focus]:text-[HighlightText]',
				// Make sure key names that are longer than one character (like 'Tab') have extra space
				index > 0 && char.length > 1 && 'pl-1',
			]))
      }, _toDisplayString(char), 3))
    }), 128)),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})